import { SVGProps } from "react";

const PersonalCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 21H7.5C3.5 21 2.5 20 2.5 16V8C2.5 4 3.5 3 7.5 3H17.5C21.5 3 22.5 4 22.5 8V16C22.5 20 21.5 21 17.5 21Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 8H19.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 12H19.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 16H19.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.9975 11.2899C9.99714 11.2899 10.8075 10.4796 10.8075 9.47992C10.8075 8.48029 9.99714 7.66992 8.9975 7.66992C7.99786 7.66992 7.1875 8.48029 7.1875 9.47992C7.1875 10.4796 7.99786 11.2899 8.9975 11.2899Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 16.3298C12.36 14.8798 11.21 13.7398 9.76 13.6098C9.26 13.5598 8.75 13.5598 8.24 13.6098C6.79 13.7498 5.64 14.8798 5.5 16.3298"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PersonalCard;
